import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  props: {
  headline: {
    type: String,
    default: ''
  },
  text: {
    type: String,
    default: ''
  },
  plurality: {
    type: Number,
    default: 0
  },
  actions: {
    type: Object,
    default: () => ({})
  },
  initialDisplayState: {
    type: Boolean,
    default: false
  },
  alternative: {
    type: Boolean,
    default: false
  },

  loading: {
    type: Boolean,
    default: false
  }
},
  emits: ['modal'],
  setup(__props, { emit }) {

const props = __props;





const display = computed({
  get() {
    return props.initialDisplayState;
  },
  set(payload) {
    emit('modal', payload);
  }
});


return { __sfc: true,props, emit, display }
}

})